import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Featured from './components/Featured';
import Footer from './components/Footer';
import { UserProvider } from './components/UserContext';
import ProtectedRoute from './components/ProtectedRoute';
import Dashboard from './pages/Dashboard';
import ResultsPage from './pages/ResultsPage';
import N404 from './components/N404';
import Calendar from './pages/Calendar';
import Favorites from './pages/Favorites';
import Home from './pages/Home';
import PlaceDetailsPage from './pages/PlaceDetailsPage';
import Toc from './pages/toc';
import Seo from './pages/Seo';
import { HelmetProvider } from 'react-helmet-async';
import ScrollToTop from './components/ScrollToTop';
import YearlySuccess from './pages/YearlySuccess';
import MonthlySuccess from './pages/MonthlySuccess';


function App() {
    return (
        <HelmetProvider>
            <UserProvider>
                <Router>
                    <ScrollToTop />
                    <Routes>
                        <Route path="/" element={<Featured />} />
                        <Route path="/home" element={<Home />} />
                        <Route path='/favorites' element={<Favorites />} />
                        <Route path='/calendar' element={<Calendar />} />
                        <Route path='/toc' element={<Toc />} />
                        <Route path='/seo' element={<Seo />} />
                        <Route path='/dashboard' element={<Dashboard />} />
                        <Route path='/yearly-success' element={<YearlySuccess />} />
                        <Route path='/monthly-success' element={<MonthlySuccess />} />
                        <Route path="/catalog" element={<ResultsPage />} /> {/* ResultsPage is linked to /catalog */}
                        <Route path="/catalog/:placeId" element={<PlaceDetailsPage />} />
                        <Route path="*" element={<N404 />} /> {/* Catch-all for unmatched routes */}
                    </Routes>
                    <Footer />
                </Router>
            </UserProvider>
        </HelmetProvider>
    );
}

export default App;
